<template>
  <div id="modal-table">
    <table class="table">
      <thead>
        <tr>
          <td
            v-for="(field, fieldIndex) in fieldsArray"
            :key="fieldIndex"
          >
            {{ field.label }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(order, orderIndex) in carts"
          :key="orderIndex"
        >
          <td>
            {{ order.created_at }}
          </td>
          <td>
            <a
              @click="
                goResultDetail(
                  order.order_id,
                  order.animal_id,
                  order.hospital_id,
                  true
                )
              "
            >
              <u>{{ order.ln }}</u>
            </a>
          </td>
          <td>
            {{ order.patient }}
          </td>
          <td>
            {{ order.spp }}
          </td>
          <td>
            {{ order.test_item }}
          </td>
          <td>
            <b-form-input
              v-model="order.price"
              :disabled="isCreateView"
              type="number"
            />
          </td>
          <td>
            <b-form-input
              v-model="order.quantity"
              :disabled="isCreateView"
              type="number"
            />
          </td>
          <td>
            {{ order.price * order.quantity }}
          </td>
          <td>
            {{ order.latest_approve.user.name }}
          </td>
        </tr>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td>
            {{ ordersCount }}
          </td>
          <td>
            {{ totalAmount }}
          </td>
          <td />
        </tr>
      </tbody>
    </table>
    <!--        <b-table-->
    <!--            class="add-document-table"-->
    <!--            :items="orders"-->
    <!--            :fields="fields"-->
    <!--            striped-->
    <!--            bordered-->
    <!--            foot-clone-->
    <!--        >-->
    <!--            <template slot="date" slot-scope="data">-->
    <!--                {{ data.item.created_at }}-->
    <!--            </template>-->
    <!--            <template slot="ln" slot-scope="data">-->
    <!--                <a-->
    <!--                    @click="-->
    <!--                        goResultDetail(-->
    <!--                            data.item.id,-->
    <!--                            data.item.animal_id,-->
    <!--                            data.item.hospital_id,-->
    <!--                            true-->
    <!--                        )-->
    <!--                    "-->
    <!--                    ><u>{{ data.item.ln }}</u></a-->
    <!--                >-->
    <!--            </template>-->
    <!--            <template slot="patient" slot-scope="data">-->
    <!--                {{ data.item.patient }}-->
    <!--            </template>-->
    <!--            <template slot="spp" slot-scope="data">-->
    <!--                {{ data.item.spp }}-->
    <!--            </template>-->
    <!--            <template slot="test" slot-scope="data">-->
    <!--                {{ data.item.test_item }}-->
    <!--            </template>-->
    <!--            <template slot="price" slot-scope="data">-->
    <!--                <b-form-input type="number" v-model="orders[data.index].price" />-->
    <!--            </template>-->
    <!--            <template slot="quantity" slot-scope="data">-->
    <!--                <b-form-input type="number" v-model="orders[data.index].quantity" />-->
    <!--            </template>-->
    <!--            <template slot="amount" slot-scope="data">-->
    <!--                {{data.item.total_price}}-->
    <!--            </template>-->
    <!--            <template slot="approver" slot-scope="data">-->
    <!--                {{ data.item.latest_approve.user.name }}-->
    <!--            </template>-->
    <!--            <template slot="FOOT_date" slot-scope="data"-->
    <!--                ><p></p>-->
    <!--            </template>-->
    <!--            <template slot="FOOT_ln" slot-scope="data"-->
    <!--                ><p></p>-->
    <!--            </template>-->
    <!--            <template slot="FOOT_patient" slot-scope="data"-->
    <!--                ><p></p>-->
    <!--            </template>-->
    <!--            <template slot="FOOT_spp" slot-scope="data"-->
    <!--                ><p></p>-->
    <!--            </template>-->
    <!--            <template slot="FOOT_test" slot-scope="data"-->
    <!--                ><p></p>-->
    <!--            </template>-->
    <!--            <template slot="FOOT_price" slot-scope="data"-->
    <!--                ><p></p>-->
    <!--            </template>-->
    <!--            <template slot="FOOT_quantity" slot-scope="data">-->
    <!--                <strong>{{ orders.length }}</strong>-->
    <!--            </template>-->
    <!--            <template slot="FOOT_amount" slot-scope="data">-->
    <!--                <strong>{{totalAmount}}</strong>-->
    <!--            </template>-->
    <!--            <template slot="FOOT_approver" slot-scope="data"> <p></p></template>-->
    <!--        </b-table>-->
  </div>
</template>

<script>
export default {
    name: "ConfirmAddDocumentTableModal",
    props: {
        orders: {
            type: Array
        },
        isCreateView: {
          type: Boolean
        }
    },
    data() {
        return {
            fields: {
              date: {
                label: "วันที่สั่งตรวจ"
              },
              ln: {
                label: "LN"
              },
              patient: {
                label: "PATIENT"
              },
              spp: {
                label: "SPP"
              },
              test: {
                label: "รายการตรวจ"
              },
              price: {
                label: "ราคาต่อหน่วย"
              },
              quantity: {
                label: "จำนวน"
              },
              amount: {
                label: "ราคารวม"
              },
              approver: {
                label: "ผู้อนุมัติ"
              },
            },
              fieldsArray: [
                {
                  label: "วันที่สั่งตรวจ"
                },
                {
                  label: "LN"
                },
                {
                  label: "PATIENT"
                },
                {
                  label: "SPP"
                },
                {
                  label: "รายการตรวจ"
                },
                {
                  label: "ราคาต่อหน่วย"
                },
                {
                  label: "จำนวน"
                },
                {
                  label: "ราคารวม"
                },
                {
                  label: "ผู้อนุมัติ"
                },
              ]
            }
    },
    computed: {
        totalAmount() {
            let total = 0;
            this.orders.forEach(order => {
                total += order.price * order.quantity
            });
            return total;
        },
      ordersCount() {
        let total = 0;
        this.orders.forEach(order => {
          total += +order.quantity;
        });
        return total;
      },
      carts: {
        get() {
          return this.$store.state.Account.carts;
        },
        set(val) {
          this.$store.commit("Account/SET_CARTS", val);
        }
      }
    },
    mounted() {
    }
};
</script>

<style scoped></style>
